import React from 'react';
import { Row, Col, Glyphicon, Button } from 'react-bootstrap'
import { Box } from 'fw/components';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import * as API from 'modules/app/API';
import * as Notifications from 'fw/globals/Notifications';

class BatchProcesses extends React.Component {
    
    executeWelcomeEmail = () => {
        API.App.post('/batchProcesses/sendWelcomeEmail', {}, {
            success: (r) => {
                Notifications.success(r.message);
            },
            error: r => {
                Notifications.error(r.error.errorMessage);
            }
        });
    }
    
    executeSponsorWelcomeEmail = () => {
        API.App.post('/batchProcesses/sendSponsorWelcomeEmail', {}, {
            success: (r) => {
                Notifications.success(r.message);
            },
            error: r => {
                Notifications.error(r.error.errorMessage);
            }
        });
    }

    executeEncryptVeteranOwnerSSN = () => {
        API.App.post('/batchProcesses/encryptVeteranOwnerSSN', {}, {
            success: (r) => {
                Notifications.success(r.message);
            },
            error: r => {
                Notifications.error(r.error.errorMessage);
            }
        });
    }

	executeIndexVOBInfo = () => {
        API.App.post('/batchProcesses/indexVOBInfo', {}, {
            success: (r) => {
                Notifications.success(r.message);
            },
            error: r => {
                Notifications.error(r.error.errorMessage);
            }
        });
    }

    executeIndexVeteranOwnerInfo = () => {
        API.App.post('/batchProcesses/indexVeteranOwnerInfo', {}, {
            success: (r) => {
                Notifications.success(r.message);
            },
            error: r => {
                Notifications.error(r.error.errorMessage);
            }
        });
    }

    executeIndexUserInfo = () => {
        API.App.post('/batchProcesses/indexUserInfo', {}, {
            success: (r) => {
                Notifications.success(r.message);
            },
            error: r => {
                Notifications.error(r.error.errorMessage);
            }
        });
    }

    executeIndexRoleInfo = () => {
        API.App.post('/batchProcesses/indexRoleInfo', {}, {
            success: (r) => {
                Notifications.success(r.message);
            },
            error: r => {
                Notifications.error(r.error.errorMessage);
            }
        });
    }

    executeIndexSponsorInfo = () => {
        API.App.post('/batchProcesses/indexSponsorInfo', {}, {
            success: (r) => {
                Notifications.success(r.message);
            },
            error: r => {
                Notifications.error(r.error.errorMessage);
            }
        });
    }

    executeNotifications = () => {
        API.Job.post('/SendNotifications', {}, {
            success: (r) => {
                Notifications.success(r.message);
            },
            error: r => {
                Notifications.error(r.error.errorMessage);
            }
        });
    }

    executePayPalInvoices = () => {
        API.Job.post('/RetrievePaypalInvoices', {}, {
            success: (r) => {
                Notifications.success(r.message);
            },
            error: r => {
                Notifications.error(r.error.errorMessage);
            }
        });
    }

    executePayPalInvoicesDetails = () => {
        API.Job.post('/RetrievePaypalInvoicesDetails', {}, {
            success: (r) => {
                Notifications.success(r.message);
            },
            error: r => {
                Notifications.error(r.error.errorMessage);
            }
        });
    }

    render() {
        return (
            <React.Fragment>
                <ContentHeader title="Batch Processes" description="Execute batch processes">
                </ContentHeader>
                <ContentBody>
                    <Box boxStyle="primary">   
                        <Row>
                            <Col md={12}>
                                <table className="table table-condensed">
                                    <thead>
                                        <tr>
                                            <th>Process</th>
                                            <th>Detail</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                Welcome Email - On-Boarding Email for VOCS <b>Legacy Users</b>
                                            </td>
                                            <td>
                                                This process will send a welcome email to all Legacy users
                                            </td>
                                            <td>
                                            <Button bsStyle="link" className="log-toggle" onClick={this.executeWelcomeEmail}>
                                                <Glyphicon glyph="play" />
                                                <span className="log" style={{ marginLeft: '5px' }}> Execute</span>
                                            </Button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Welcome Email - On-Boarding Email for VOCS <b>Sponsor Users</b>
                                            </td>
                                            <td>
                                                This process will send a welcome email to all Sponsor users
                                            </td>
                                            <td>
                                            <Button bsStyle="link" className="log-toggle" onClick={this.executeSponsorWelcomeEmail}>
                                                <Glyphicon glyph="play" />
                                                <span className="log" style={{ marginLeft: '5px' }}> Execute</span>
                                            </Button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Encrypt Veteran Owners' <b>SSN</b>
                                            </td>
                                            <td>
                                                This process will encrypt all stored Veteran owners' SSN
                                            </td>
                                            <td>
												<Button bsStyle="link" className="log-toggle" onClick={this.executeEncryptVeteranOwnerSSN}>
													<Glyphicon glyph="play" />
													<span className="log" style={{ marginLeft: '5px' }}> Execute</span>
												</Button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Index <b>User</b>
                                            </td>
                                            <td>
                                                This process will index User Information
                                            </td>
                                            <td>
                                                <Button bsStyle="link" className="log-toggle" onClick={this.executeIndexUserInfo}>
                                                    <Glyphicon glyph="play" />
                                                    <span className="log" style={{ marginLeft: '5px' }}> Execute</span>
                                                </Button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Index <b>Role</b>
                                            </td>
                                            <td>
                                                This process will index Role Information
                                            </td>
                                            <td>
                                                <Button bsStyle="link" className="log-toggle" onClick={this.executeIndexRoleInfo}>
                                                    <Glyphicon glyph="play" />
                                                    <span className="log" style={{ marginLeft: '5px' }}> Execute</span>
                                                </Button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Index <b>VeteranOwners</b>
                                            </td>
                                            <td>
                                                This process will index Veteran owners information
                                            </td>
                                            <td>
                                                <Button bsStyle="link" className="log-toggle" onClick={this.executeIndexVeteranOwnerInfo}>
                                                    <Glyphicon glyph="play" />
                                                    <span className="log" style={{ marginLeft: '5px' }}> Execute</span>
                                                </Button>
                                            </td>
                                        </tr>
										<tr>
                                            <td>
                                                Index <b>VOBs</b>
                                            </td>
                                            <td>
                                                This process will index VOBs information
                                            </td>
                                            <td>
                                                <Button bsStyle="link" className="log-toggle" onClick={this.executeIndexVOBInfo}>
                                                    <Glyphicon glyph="play" />
                                                    <span className="log" style={{ marginLeft: '5px' }}> Execute</span>
                                                </Button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Index <b>Corporate Members</b>
                                            </td>
                                            <td>
                                                This process will index Corporate Members information
                                            </td>
                                            <td>
                                                <Button bsStyle="link" className="log-toggle" onClick={this.executeIndexSponsorInfo}>
                                                    <Glyphicon glyph="play" />
                                                    <span className="log" style={{ marginLeft: '5px' }}> Execute</span>
                                                </Button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Notifications Job
                                            </td>
                                            <td>
                                                This process will run Notifications job
                                            </td>
                                            <td>
                                                <Button bsStyle="link" className="log-toggle" onClick={this.executeNotifications}>
                                                    <Glyphicon glyph="play" />
                                                    <span className="log" style={{ marginLeft: '5px' }}> Execute</span>
                                                </Button> 
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Get Paypal Invoices
                                            </td>
                                            <td>
                                                This process will run job retrieving all paypal invoices.
                                            </td>
                                            <td>
                                                <Button bsStyle="link" className="log-toggle" onClick={this.executePayPalInvoices}>
                                                    <Glyphicon glyph="play" />
                                                    <span className="log" style={{ marginLeft: '5px' }}> Execute</span>
                                                </Button> 
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Get Paypal Invoices - pending details
                                            </td>
                                            <td>
                                                This process will run job retrieving all paypal invoices Details.
                                            </td>
                                            <td>
                                                <Button bsStyle="link" className="log-toggle" onClick={this.executePayPalInvoicesDetails}>
                                                    <Glyphicon glyph="play" />
                                                    <span className="log" style={{ marginLeft: '5px' }}> Execute</span>
                                                </Button> 
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                    </Box>
                </ContentBody>
            </React.Fragment>
        );
    }
}

export default BatchProcesses;



// WEBPACK FOOTER //
// ./src/areas/admin/batchProcesses/BatchProcesses.js